/**
 * @fileoverview Photo Content View - Handles UI interactions for the photo in the social post
 *
 * @author Samantha Landen (slanden@yext.com)
 */
goog.module('yext.social.post.PhotoContentView');
goog.module.declareLegacyNamespace();

const yext = goog.require('yext');
const assetselector = goog.require('yext.dam.assetselector');
const events = goog.require('yext.dam.assetselector.events');
const usage = goog.require('yext.dam.assetselector.usage');
const Model = goog.require('yext.mvc.Model');

/** @constructor */
const PhotoContentView = function(options) {
  this.options = options || {};

  /** @type {!jQuery} */
  this.$el = this.options.$el || $('.js-post-photo-container');
  this.assetUsage = usage.forSocialPosting();

  /**
   * @type {Model}
   * @private
   */
  this.model_ = new Model().init({
    asset: null,
    photo: null,
  });

  /**
   * @type {Function}
   * @private
   */
  this.onChange_ = null;
};

/** @return this */
PhotoContentView.prototype.init = function() {
  assetselector.init();
  this.bindAddPhoto_();
  this.bindRemovePhoto_();
  this.bindModelChange_();
  return this;
};

/** @param {Function} cb */
PhotoContentView.prototype.onChange = function(cb) {
  if (!yext.isFunction(cb)) {
    throw new TypeError('PhotoContentView.onChange: Invalid cb, expected a function');
  }
  this.onChange_ = cb;
};

/** @return {!Object<string, ?>} */
PhotoContentView.prototype.getData = function() {
  return {
    // asset represents an object after we save using asset selector plugin
    'asset': this.model_.get('asset'),
    // photo represents an object that we get after we upload a photo
    'photo': this.model_.get('photo'),
  };
};

/** Removes the photo data */
PhotoContentView.prototype.reset = function() {
  this.model_.resetState('asset', null);
  this.model_.resetState('photo', null);
};

/**
 * Sets the photo
 * @param {!Object<string, ?>} photo
 */
PhotoContentView.prototype.setPhoto = function(photo) {
  var photoUrl = photo['url'] || null;
  this.model_.set('photo', photoUrl == null ? null : photo);
  if (this.model_.get('asset') == null) {
    this.model_.set('asset', photoUrl === null ? null : {
      photoUrl: photoUrl,
    });
  }
};

/** @private */
PhotoContentView.prototype.bindAddPhoto_ = function() {
  this.$el.on('click', '.js-no-photo', function() {
    assetselector.show({
      type: assetselector.types.PHOTO,
      includeUsedAssets: true,
      locationSearchParam: this.options.getLocationSearchParam(),
      usageType: this.assetUsage,
    },
    'socialPostPhoto',
    null, {
      // NOTE(mattjs) This fixes a google photo sizing issue
      // re: https://yextops.zendesk.com/agent/tickets/148640
      'cropOnlyOnInteraction': false,
    });

    $(assetselector.events).on('added.assetselector', function(e, asset) {
      this.model_.set('asset', asset);
    }.bind(this));
  }.bind(this));
};

/** @private */
PhotoContentView.prototype.bindRemovePhoto_ = function() {
  this.$el.on('click', '.js-remove-photo', function() {
    this.reset();
  }.bind(this));
};

/** @private */
PhotoContentView.prototype.bindModelChange_ = function() {
  this.model_.on('change:asset,change:photo,reset', function() {
    this.render_();
    if (this.onChange_) {
      this.onChange_(this.getData());
    }
  }.bind(this));
};

/** @private */
PhotoContentView.prototype.render_ = function() {
  var imgUrl = '';
  if (this.model_.get('asset')) {
    var asset = this.model_.get('asset');
    imgUrl = asset.croppedImage || asset.photoUrl;
  }

  this.$el.find('.js-no-photo').toggle(imgUrl.length == 0);
  this.$el.find('.js-inner-photo-container').toggle(imgUrl.length != 0)
    .find('.js-post-photo').attr('src', imgUrl);
};

exports = PhotoContentView;
